import React from 'react';
import { TipoAcessoAuditoria } from '../../../interfaces/IClienteAcessoAuditoria';
import { TRIBUTOS_PERMITIDOS_TRIAL } from '../interfaces/IAuditoria';

interface Props {
  tier: TipoAcessoAuditoria | null | undefined;
}

const AuditoriaTierBanner: React.FC<Props> = ({ tier }) => {
  if (!tier || tier === 'FullPremium' || tier === 'Enterprise') return null;

  if (tier === 'Diagnostico') {
    return (
      <div className='alert alert-light-info border border-info p-4 mb-4 d-flex align-items-center gap-3'>
        <i className='bi bi-bar-chart-line fs-2 text-info' />
        <div>
          <div className='fw-bolder text-info mb-1'>Modo Diagnóstico — Camada 1</div>
          <div className='text-muted fs-8'>
            Você está visualizando apenas o resumo do risco (totais e mapa de calor).
            As ocorrências detalhadas estão disponíveis nos planos Trial e Full Premium.
          </div>
        </div>
      </div>
    );
  }

  if (tier === 'Trial72h') {
    return (
      <div className='alert alert-light-warning border border-warning p-4 mb-4 d-flex align-items-center gap-3'>
        <i className='bi bi-clock-history fs-2 text-warning' />
        <div>
          {/* Contagem calculada a partir de TRIBUTOS_PERMITIDOS_TRIAL — evita o texto ficar
              desatualizado toda vez que um módulo é liberado/removido do trial (já aconteceu:
              este banner dizia "12" com a lista já tendo 15 itens). */}
          <div className='fw-bolder text-warning mb-1'>Trial 72 h — Camada 2 ({TRIBUTOS_PERMITIDOS_TRIAL.length} módulos liberados, 100% dos dados)</div>
          <div className='text-muted fs-8'>
            Você vê 100% dos resultados nos módulos liberados para o trial. Os demais módulos
            continuam somando no resumo da aba TODOS, mas não podem ser abertos individualmente.
            Faça upgrade para Full Premium e libere todos os módulos.
          </div>
        </div>
        <span className='badge badge-light-danger ms-auto'>UPGRADE</span>
      </div>
    );
  }

  if (tier === 'Nenhum') {
    return (
      <div className='alert alert-light-danger border border-danger p-4 mb-4 d-flex align-items-center gap-3'>
        <i className='bi bi-lock fs-2 text-danger' />
        <div>
          <div className='fw-bolder text-danger mb-1'>Acesso Bloqueado</div>
          <div className='text-muted fs-8'>
            Seu plano atual não inclui o módulo de Revisor Contábil.
            Entre em contato com o suporte Ainumera para habilitar o acesso.
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default AuditoriaTierBanner;
